<template>
    <section class="home-wrapper">
        <div class="home-content">
            <video autoplay loop playsinline muted src="../assets/home.mp4"></video>
            <div>
                <h2>透透医美</h2>
                <h4>取悦你的美</h4>
                <span>Find the beauty that pleases you</span>
                <div class="home-button-wrapper">
                    <a href="javascript:;" @click="download">
                        <img class="type-icon" :src="require('@/assets/iphone_icon.png')" alt="">
                            IOS版
                        <div class="qr-wrapper">
                            <img :src="require('@/assets/ios.png')" />
                        </div>
                    </a>
                    <a href="javascript:;" @click="download">
                        <img class="type-icon" :src="require('@/assets/ad_icon.png')" alt="">
                        安卓版
                        <div class="qr-wrapper">
                            <img :src="require('@/assets/android.png')" />
                        </div>
                    </a>
                </div>
            </div>
        </div>
        <div class="home-copy-right">
            <div class="copy-right">
                Copyright &copy; 2019 透透医美 备案号：蜀ICP备18010216号-1 <br />
                联系地址：中国(四川)自由贸易试验区成都高新区天府软件园B区
            </div>
        </div>
    </section>
</template>
<script>
let isAndroid = ''
let isiOS = ''
function isAndroid_ios() {
    const u = navigator.userAgent, app = navigator.appVersion;
    isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
    isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    return isAndroid==true?true:false;
}
export default {
    methods: {
        download() {
            isAndroid_ios()

            if (isAndroid) {
                console.log('安卓')
                // 安卓
                window.location.href = 'http://zhushou.360.cn/detail/index/soft_id/3841835?recrefer=SE_D_'
            } 
            if (isiOS) {
                // ios
                window.location.href = 'https://apps.apple.com/cn/app/透透医美-爱美女性精选的整形美容比价信息平台/id1102277119'
            }
        }
    }
}
</script>

<style lang="less">
.home-wrapper {
    position: absolute;
    height: 100vh;
    background: url(../assets/home_bg.png) no-repeat;
    background-size: cover;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 5;
    video {
        width: 243px;
        height: 476px;
        object-fit: contain;
    }
}
.home-content {
    position: absolute;
    width: 598px;
    height: 476px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    h2 {
        font-size: 48px;
        margin-bottom: 10px;
        font-weight: 365;
    }
    h4 {
        font-size: 31px;
        margin-bottom: 30px;
        font-weight: 320;
    }
    span {
        font-size: 18px;
        font-weight: 200;
    }
}
.home-button-wrapper {
    margin-top: 30px;
    a {
        position: relative;
        display: inline-block;
        width:129px;
        background:rgba(255,255,255,1);
        border-radius:26px;
        color: #1A1A1A;
        text-align: center;
        padding: 15px 0;
        margin-right: 17px;
        vertical-align: middle;
        &:hover {
            color: #1A1A1A;
            & .qr-wrapper {
                display: block;
            }
        }
        .type-icon {
            width: 18px;
            vertical-align: middle;
            margin-bottom: 3px;
        }
        .qr-wrapper {
            display: none;
            position: absolute;
            top: 60px;
            width: 129px;
            height: 129px;
            padding: 12px;
            border-radius: 12px;
            background: #fff;
            img {
                width: 100%;
                height: 100%;
            }
        }
    }
}
.home-copy-right {
    position: fixed;
    bottom: 72px;
    left: 0;
    width: 100%;
    text-align: center;
    color: #FFFFFF;
    font-size: 12px;
    opacity: 0.65;
}
@media (max-width: 710px) {
    video {
        display: none !important;
    }
    .home-content {
        width: 100%;
        padding: 0 32px;
    }
    .home-button-wrapper {
        margin-top: 100px;
    }
    .home-copy-right {
        display: none;
    }
    .home-button-wrapper {
        a {
            &:hover {
                & .qr-wrapper {
                    display: none;
                }
            }
        }
    }
}

</style>
